import Resource from '@/plugins/sdk/Resource'
import { STRING, NUMBER, UUID, ITEM } from '@/plugins/sdk/fields'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Service from '@/plugins/sdk/resources/Carrier/Service'

export default class extends Resource {
  static name = 'carrier_time'

  static get fields () {
    return {
      id: new UUID(),
      carrier: new ITEM(Carrier),
      service: new ITEM(Service),
      from: new STRING(),
      to: new STRING(),
      travel_time: new NUMBER()
    }
  }
}
